import { render } from "./programs.vue?vue&type=template&id=9ca29840&scoped=true"
import script from "./programs.vue?vue&type=script&lang=js"
export * from "./programs.vue?vue&type=script&lang=js"

import "./programs.vue?vue&type=style&index=0&id=9ca29840&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-9ca29840"

export default script